import React from 'react';
import PropTypes from 'prop-types'; 
import './search-result-detailed.scss';
import { Link } from 'react-router-dom';
import SearchResultDetailedRow from '../search-result-detailed-row/SearchResultDetailedRow';

const SearchResultDetailed = ({ results, type }) => {
    const renderResults = () => {
        if (type.includes('all')) {
            return results.map((result, index) => {
                if (index <= 2) {
                    return <SearchResultDetailedRow key={`key-${index}`} result={result} />;
                } else if (index === results.length - 1) {
                    return (
                        <React.Fragment key={`key-${index}`}>
                            <tr className='view-all-row'>
                                <td colSpan="8" className='text-right'>
                                    <Link to={`/searchresults/${result.title.toLowerCase()}`}>View All</Link>
                                </td>
                            </tr>
                        </React.Fragment>
                    );
                } else {
                    return null;
                }
            });
        } else {
            return results.map((result) => (
                <SearchResultDetailedRow key={result.Id} result={result} />
            ));
        }
    };

    return (
        <>
            {renderResults()}
        </>
    );
};

SearchResultDetailed.propTypes = {
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
    type: PropTypes.string.isRequired
};
export default SearchResultDetailed;